import { useQuery } from "@tanstack/react-query";
import { listIngredientScores } from "@/lib/ingredients.functions";

/** Φορτώνει μία φορά τον χάρτη σκορ συστατικών και επιστρέφει το σκορ ενός προϊόντος. */
export function useIngredientScore(productId: string | undefined): number | null {
  const { data } = useQuery({
    queryKey: ["ingredient-scores"],
    queryFn: () => listIngredientScores(),
    staleTime: 30 * 60_000,
    gcTime: 60 * 60_000,
  });
  if (!productId) return null;
  return data?.scores[productId] ?? null;
}
